import React, { useEffect, useState } from "react";
import {
  CloseXIcon,
  DownIcon,
  LastIcon,
  NextIcon,
  CloseIcon,
  LogoIcon,
  LastIconDisable,
  NextIconDisable,
  DownTriangle,
  SingleBlockShareIcon,
} from "../../static/svg";
import {
  FacebookShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
} from "react-share";
import * as html2canvas from "html2canvas";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import message from "components/message";
import { getCookie } from "utils/getCookie";
import { collectFunc } from "components";
import { setFW700 } from "utils/handle_data";
import "./index.less";
import NFT_01 from "assets/img/NFT_01.png";
import NFT_02 from "assets/img/NFT_02.png";
import NFT_03 from "assets/img/NFT_03.png";
import NFT_04 from "assets/img/NFT_04.png";
import NFT_05 from "assets/img/NFT_05.png";
import NFT_06 from "assets/img/NFT_06.png";
import donwnLoad1 from "assets/img/Checkpoint1.png";
import donwnLoad2 from "assets/img/Checkpoint2.png";
import donwnLoad3 from "assets/img/Checkpoint3.png";
import donwnLoad4 from "assets/img/Checkpoint4.png";
import donwnLoad5 from "assets/img/Checkpoint5.png";
import donwnLoad6 from "assets/img/Checkpoint6.png";
import donwnLoad7 from "assets/img/Checkpoint7.png";
import donwnLoad8 from "assets/img/Checkpoint8.png";
import donwnLoad9 from "assets/img/Checkpoint9.png";
import donwnLoad10 from "assets/img/Checkpoint10.png";
import donwnLoad11 from "assets/img/Checkpoint11.png";
import donwnLoad12 from "assets/img/Checkpoint12.png";
import donwnLoad13 from "assets/img/Checkpoint13.png";
import donwnLoad14 from "assets/img/Checkpoint14.png";
import donwnLoad15 from "assets/img/Checkpoint15.png";
import donwnLoad16 from "assets/img/Checkpoint16.png";
import donwnLoad17 from "assets/img/Checkpoint17.png";
import donwnLoad18 from "assets/img/Checkpoint18.png";
import donwnLoad19 from "assets/img/Checkpoint19.png";
import donwnLoad20 from "assets/img/Checkpoint20.png";
import ButtonIcon from "assets/img/ButtonIcon.png";
import NoSightWhiteIcon from "assets/img/no-sight-white.png";
import SightWhiteIcon from "assets/img/visible-sight-white.png";
import donwnLoadGateQr from "assets/img/donwnLoadGateQr.png";
import gateioLogo from "assets/img/keyword/gateio_logo.png";

import { Encrypt } from "utils/secret";
import {
  achievementsID,
  THIS_YEAR,
  totleDataSourceNum,
  keywordID,
} from "utils/consts";
import { KeyWordComponent } from "../keyword";
import defaultAvatarImg from "assets/img/default-avatar.png";
import { renderKeywordBackground, dataURLtoBlob } from "utils/tool";
import { shareToPost, getToken, uploadImgSher } from "utils/request";
import Loading from "../main/loading";

const collectList = [
  "birthplace",
  "gloryhall",
  "friendship",
  "annualtrading",
  "spotcity",
  "futuresfairyland",
  "gatemetaverse",
  "startupcity",
  "earnhall",
  // 余币宝
  "uniloan",
  // 财富管理
  "wealth",
  "ETFddomain",
  "NFTworld",
  "strategybot",
  "copytrading",
  "gatelearn",
  "gateworld",
  "gatelive",
  "gate.iomonument",
  // 关键词
  "keyword",
  "share",
  "gift",
];

const DonwnLoadGateWayFooter = () => {
  const t = window.t;

  return (
    <div className="donwnLoadGateWayFooterBox" style={{ display: "none" }}>
      <div className="GateWayLeft">
        <img className="gatelogo" src={gateioLogo} alt="logo" />
        <span>{t("home.gatewayToCrypto")}</span>
      </div>

      <img className="donwnLoadGateQr" src={donwnLoadGateQr} alt="" />
    </div>
  );
};

function ShareContent({
  visibility: showShare,
  close,
  dataSoure,
  switchingData,
  annualData,
  clickList,
  userName,
  setAlreadyChooseNFT,
}) {
  const [visibility, setVisibility] = useState({ display: "none" }); // 弹窗遮罩显示
  const [showNum, setShowNum] = useState(true); // 敏感字符的展示
  // 分享组件是否展示
  const [showShareBlock, setShowShareBlock] = useState(false);
  // 是否已发放NFT
  const [ownNFT, setOwnNFT] = useState(false);
  // 选择的 NFT 索引
  const [NFTcurrentIndex, setNFTcurrentIndex] = useState(0);
  // 第18个区块, 分享区块的title
  const [shareBlocktitle, setShareBlocktitle] = useState("");
  // 展示分享tip
  const [showTipShareBlock, setShowTipShareBlock] = useState(false);
  // 分享链接
  const [shareUrl, setShareUrl] = useState(
    "https://www.gate.io/your-year-in-review",
  );
  // 分享文案
  const [shareText, setShareText] = useState("");
  const [blcokReturn, setBlcokReturn] = useState(false);
  // 单个分享区块的id
  const [singleId, setSingleId] = useState(null);
  const [momentToken, setMomentToken] = useState("");

  // 加载状态
  const [isLoading, setIsLoading] = useState(false);

  const t = window.t;
  // 如果是关键词模块
  const isKeywordBlock = dataSoure.data.id === keywordID;

  const canChooseNFT = clickList.length === 19;

  let isApp = false;
  if (window.$$device_type) {
    isApp = `${window.$$device_type === 1 ? "android" : "ios"}`;
  }
  const uniqueKey = getCookie("sign") || getCookie("pver");
  const uid = getCookie("uid");

  useEffect(() => {
    if (showShare) {
      setVisibility({});
      document.body.classList.add("shareBody");
    }
    return () => {
      document.body.classList.remove("shareBody");
    };
  }, [showShare]);

  useEffect(() => {
    setShareBlocktitle(t("Congratulations"));
    setShareText(t("share_single_block_text", { thisYear: THIS_YEAR }));
    // TODO:  share 页初始化时需要查询一下NFT是否已拥有，nft功能暂时不需要了
    // sendNFT().then((res) => {
    //   const { code } = res;
    //   if (code === 20000) {
    //     const { data } = res;
    //     const { is_send_nft, style } = data;
    //     if (is_send_nft) {
    //       setOwnNFT(is_send_nft);
    //       setNFTcurrentIndex(nftStyleList.indexOf(style));
    //     }
    //   }
    // });

    const main = document.querySelector(".main");

    let mainScroll;
    if (main) {
      mainScroll = main.addEventListener(
        "scroll",
        throttle(() => {
          let scrollTop = main.scrollTop;
          // 当 achievements 滑上去时，切换 title
          setShowTipShareBlock(false);
          setSingleId(null);
          if (scrollTop > 130) {
            setShareBlocktitle(t("Your achievements"));
          } else {
            setShareBlocktitle(t("Congratulations"));
          }
        }),
      );
    }

    let windowClick = window.addEventListener("click", (e) => {
      if (
        !e.target.closest(".tip-share-button") &&
        !e.target.closest(".single-block-share-icon")
      ) {
        setShowTipShareBlock(false);
        setSingleId(null);
      }
    });

    return () => {
      if (main && main.removeEventListener) {
        main.removeEventListener("scroll", mainScroll);
      }
      if (window.removeEventListener) {
        window.removeEventListener("click", windowClick);
      }
    };
  }, []);

  let timer = null;
  const changeNftJumpUrl = () => {
    timer = setInterval(() => {
      const timeToSeeNFTEle = document.querySelector(".time-to-see-NFT a");
      if (timeToSeeNFTEle) {
        clearInterval(timer);
        let searchStr = window.location.search;
        searchStr = searchStr.replace(/^\?/, "&");
        timeToSeeNFTEle.href = "/nft_app?entry=Asset" + searchStr;
      }
    }, 100);
  };

  useEffect(() => {
    window.$$device_type && changeNftJumpUrl();
    let list = document.querySelectorAll(".hiddenHtml");
    list.forEach((ele) => {
      ele.setAttribute("value", ele.innerText);
      if (!showNum) {
        if (ele.innerText.indexOf("USDT") >= 0) {
          ele.innerText = " **** USDT";
        } else if (ele.innerText.indexOf("%") >= 0) {
          ele.innerText = " **** %";
        } else {
          ele.innerText = " **** ";
        }
      }
    });
    handleShareUrl();
  }, [dataSoure.data.id]);

  // 上传图片信息到七牛云
  async function uploadImgs(image) {
    const putExtra = {
      fname: "",
      customVars: {
        "x:category": "emoticon",
      },
      mimeType: ["image/png", "image/jpeg", "image/jpg", "image/gif"],
    };
    const config = {
      useCdnDomain: true,
      disableStatisticsReport: true,
      retryCount: 3,
      forceDirect: true,
    };

    const { data: res } = await uploadImgSher({
      momentToken,
    });

    if (res.resMsg && res.resMsg.code == 0) {
      const { token, key } = res.datas;
      // const allUploadPromise = (() => {
      return new Promise((res, rej) => {
        const observer = {
          next(result) {
            // console.log('next', result)
          },
          error(error) {
            // console.log('error', error)
            rej("upload error", error);
          },
          complete(result) {
            // console.log('complete', result)
            res(result);
          },
        };
        const ukey = `${key}-0`;
        let observable = window.qiniu.upload(
          image,
          ukey,
          token,
          putExtra,
          config,
        );
        observable.subscribe(observer);
      });
    } else {
      message({
        type: "noIcon",
        content: res.resMsg?.message,
      });
    }
  }

  // 下载当前页面
  let donwnFlag = false;
  const downPage = async (_, isSher) => {
    if (donwnFlag) return;
    setIsLoading(true); // 开启加载中状态
    donwnFlag = true;
    const downloadImgList = {
      1: donwnLoad1,
      2: donwnLoad2,
      3: donwnLoad3,
      4: donwnLoad4,
      5: donwnLoad5,
      6: donwnLoad6,
      7: donwnLoad7,
      8: donwnLoad8,
      9: donwnLoad9,
      10: donwnLoad10,
      11: donwnLoad11,
      12: donwnLoad12,
      13: donwnLoad13,
      14: donwnLoad14,
      15: donwnLoad15,
      16: donwnLoad16,
      17: donwnLoad17,
      18: donwnLoad18,
      20: donwnLoad19,
      21: donwnLoad20,
    };
    let png_name =
      dataSoure.data.id === achievementsID
        ? t("Your achievements")
        : dataSoure.data.id === keywordID
        ? t("my.narrative", {
            thisYear: THIS_YEAR,
          })
        : dataSoure.data.id === 19
        ? t("NFTBtn")
        : dataSoure.data.title;
    function screenshot(Element, filename) {
      let newElement = Element.cloneNode(true);
      const keywordBlockDownload = isKeywordBlock
        ? "isKeywordBlockDownload"
        : "isDownload";
      newElement.classList.add(
        "download",
        isSher ? "isSher" : keywordBlockDownload,
      );
      document.body.appendChild(newElement);

      const downloadContent = newElement.querySelector(".download .content");
      if (downloadContent) {
        downloadContent.classList = ownNFT
          ? "share-centerner share-centerner-mt-30"
          : dataSoure.data.id === keywordID
          ? "downloadContent linear-border keyword-download-container"
          : "downloadContent linear-border";
      }
      newElement.querySelector(".download .centernerTitle").style.display =
        "none";

      const downloadIconBox = newElement.querySelector(".download .iconBox");
      if (!isKeywordBlock) {
        downloadIconBox.innerHTML = `<span>${LogoIcon()}</span><span style="margin-right: 0;word-break: break-all">${png_name}</span>`;

        newElement.querySelector(".download .centerner").style.height = "auto";
        newElement.querySelector(".download .imgBox img").src =
          downloadImgList[dataSoure.data.id];
        newElement.querySelector(".download .nextBox").style.display = "none";
        newElement.querySelector(".download .shareButton").style.display =
          "none";
        newElement.querySelector(".download .share-laws-text").style.display =
          "none";
      }

      const shareBlockWrap = newElement.querySelector(
        ".download .share-block-wrap",
      );
      if (shareBlockWrap) {
        shareBlockWrap.style.display = "none";
      }

      let singleBlockContent = newElement.querySelectorAll(
        ".single-block-content-icon-hidden",
      );
      if (dataSoure?.data.id == achievementsID) {
        document.querySelector(".download").classList.add("share-centerner-bg");
        singleBlockContent.forEach((item) => {
          item.className = "single-block-content-icon";
        });
      }

      const downloadShareCenterner = newElement.querySelector(
        `.download  ${ownNFT ? ".share-centerner " : ".downloadContent"}`,
      );

      if (downloadShareCenterner) {
        downloadShareCenterner.classList.remove("show-share-block");
      }

      if (dataSoure?.data?.id === achievementsID) {
        const svgList = document.querySelectorAll(
          ".download .single-block-share-icon",
        );
        svgList.forEach((ele) => (ele.style.display = "none"));
      }
      if (isKeywordBlock) {
        downloadIconBox.style.display = "none";
        newElement.querySelector(".download .avatar-wraper").style.marginTop =
          "16px";
        newElement.querySelector(
          ".download .keyword-share-button-wraper",
        ).style.display = "none";

        // 将avatar的img换成默认的地址
        const avatarImg = document.querySelector(
          "#shareWrap.download .keyword-avatar-img",
        );
        if (avatarImg) {
          avatarImg.src = defaultAvatarImg;
        }

        const downloadInnerContent = document.querySelector(
          ".download .inner-content",
        );
        // 下载底部增加页面信息
        if (!isSher) {
          const donwnLoadGateWayFooterBox = document.querySelector(
            ".download .donwnLoadGateWayFooterBox",
          );
          if (donwnLoadGateWayFooterBox)
            donwnLoadGateWayFooterBox.style.display = "flex";

          if (downloadInnerContent) {
            downloadInnerContent.style.borderBottomLeftRadius = "0px";
            downloadInnerContent.style.borderBottomRightRadius = "0px";
          }
        } else {
          if (downloadInnerContent) {
            // fix 暗黑动态圆角白色问题
            downloadInnerContent.style.borderRadius = "0px";
          }
        }
      }
      if (newElement.querySelector("#downloadChangeTitle")) {
        //下载长图 需要标题
        newElement.querySelector(
          ".download #downloadChangeTitle",
        ).style.display = "block";
        newElement.querySelector("#downloadChangeTitle").innerText =
          t("Congratulations");
      }

      setTimeout(() => {
        //   id 18  分享模块 1倍下载  图太长   其他模块 2倍下载  提高清晰度
        // 关键词分享到动态的话，需要拿里边的卡片
        const canvasContainer = isSher
          ? newElement.querySelector(".downloadContent .inner-content")
          : newElement;
        html2canvas(canvasContainer, {
          useCORS: true,
          scale: 2,
          allowTaint: true,
        }).then(function (canvas) {
          const imgData = canvas.toDataURL();
          const saveFile = function (data, filename) {
            const save_link = document.createElement("a");
            save_link.href = data;
            save_link.download = filename;
            const event = document.createEvent("MouseEvents");
            event.initMouseEvent("click", true);
            save_link.dispatchEvent(event);
          };

          if (!isSher) {
            saveFile(imgData, filename);
            setIsLoading(false);
          } else {
            const dataURL = canvas.toDataURL("image/png");
            // 将 data URL 转换为 Blob 对象
            const _blob = dataURLtoBlob(dataURL);

            uploadImgs(_blob)
              .then((res) => {
                if (res) handleShareToPost(res.key);
              })
              .catch(() => {
                message({
                  type: "noIcon",
                  content: t("Load failed, please try again!"),
                });
              })
              .finally(() => {
                setIsLoading(false); // 关闭加载中状态
              });
          }
          document.body.removeChild(newElement);
          donwnFlag = false;
        });
      }, 1000);
    }

    try {
      screenshot(document.querySelector("#shareWrap"), png_name + ".png");
    } catch (error) {
      setIsLoading(false); // 关闭加载中状态
      console.log(error);
    }
  };

  // 切换下一个
  const Switching = (type) => {
    return () => {
      const { data, initArea, index } = dataSoure;
      let dataIndex = index;
      let showMysteriousGift = false;
      if (index + 1 === initArea.length - 1) {
        // showMysteriousGift = true;
      }
      //下一个
      if (type) {
        if (dataIndex < totleDataSourceNum - 1) {
          dataIndex = index + 1;
          switchingData({
            initArea,
            data: initArea[index + 1],
            index: dataIndex,
            showMysteriousGift,
          });
        }
      } else {
        //上一个
        if (data?.id > 1) {
          dataIndex = index - 1;
          switchingData({
            initArea,
            data: initArea[index - 1],
            index: dataIndex,
          });
        }
      }
    };
  };

  const closePage = () => {
    let contentOut = document.querySelector(".content");
    contentOut.classList.add("contentOut");
    collectFunc({
      eventName: "annualbillpage_return_click",
      params: { page_name: collectList[dataSoure.index] },
    });
    setTimeout(() => {
      close(false);
    }, 250);
    document
      .getElementById(`click_area_${dataSoure?.data?.id}`)
      .scrollIntoView({ behavior: "smooth", block: "center" });
  };

  // 加密分享的url；
  const handleEncrypt = (id) => {
    if (!id) return;
    const g_lang = window.g_lang ? `${window.g_lang}/` : "";
    const params = `?id=${id}&name=${userName}&show=${
      showNum ? "1" : "0"
    }&uid=${uid}&${isApp ? "api_sign" : "api_pver"}=${uniqueKey}&userGender=${
      getCookie("gender") || 0
    }`;
    const encrypedSearch = Encrypt(params);
    const encrypedUrl = `https://www.gate.io/${g_lang}your-year-in-review?p=${encrypedSearch}&ch=annual_20231213`;
    return encrypedUrl;
  };

  // 处理分享的url
  const handleShareUrl = (singleBlockId = null) => {
    let id = dataSoure?.data?.id;
    if (singleBlockId) {
      id = singleBlockId;
    }

    const encrypedUrl = handleEncrypt(id);

    setShareUrl(encrypedUrl);
  };

  const deviceType = +window.$$device_type || 0;
  const mobileShare = (mobileShareUrl) => {
    const url = mobileShareUrl || shareUrl;
    try {
      if (deviceType === 1) {
        window.gateio.shareNative(
          JSON.stringify({
            image: "",
            title: shareText,
            text: shareText + url,
          }),
        );
      } else if (deviceType === 2) {
        window.webkit.messageHandlers.shareUrl.postMessage(
          JSON.stringify({
            webUrl: url,
            webTitle: shareText,
          }),
        );
      }
    } catch {
      console.log("not mobile device");
    }
  };

  // share 事件
  const handleShare = (type = true) => {
    return () => {
      if (dataSoure.data.id === achievementsID) {
        Switching(1)();
        setShowShareBlock(false);
        return;
      }
      handleShareUrl();
      // App内部原生分享。Android IOS 分开处理。
      setTimeout(() => {
        if (deviceType) {
          const mobileShareUrl = handleEncrypt(dataSoure.data.id);
          mobileShare(mobileShareUrl);
        } else {
          if (type) {
            setBlcokReturn(false);
          } else {
            setBlcokReturn(true);
          }
          setShowShareBlock(type);
        }
      }, 10);
    };
  };

  // 第17个区块的内部小分享
  const handleSingleShareClick = (index) => {
    setSingleId(index);
    handleShareUrl(index + 1);
    if (deviceType) {
      const mobileShareUrl = handleEncrypt(index + 1);
      mobileShare(mobileShareUrl);
    } else {
      setShowTipShareBlock(true);
    }
  };

  // 点击外部区域，关闭区块详情
  const blcokWrapClose = (e) => {
    if (e.target.id === "shareWrap") {
      let contentOut = document.querySelector(".content");
      contentOut.classList.add("contentOut");
      collectFunc({
        eventName: "annualbillpage_return_click",
        params: { page_name: collectList[dataSoure.index] },
      });
      setTimeout(() => {
        close(false);
      }, 250);
      document
        .getElementById(`click_area_${dataSoure?.data?.id}`)
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // 复制到剪切板
  const clipBoard = () => {
    if (navigator.clipboard && Number(window.$$device_type) !== 1) {
      // clipboard api 复制
      navigator.clipboard.writeText(shareUrl);
      message({ content: t("The link has been copied successfully") });
    } else {
      var textarea = document.createElement("textarea");
      document.body.appendChild(textarea);
      // 隐藏此输入框
      textarea.style.position = "fixed";
      textarea.style.clip = "rect(0 0 0 0)";
      textarea.style.top = "10px";
      // 赋值
      textarea.value = shareUrl;
      // 选中
      textarea.select();
      // 复制
      document.execCommand("copy", true);
      // 移除输入框
      document.body.removeChild(textarea);
      message({ content: t("The link has been copied successfully") });
    }
  };
  //分享埋点
  const beforeOnClick = () => {
    collectFunc({
      eventName: "annualbillpage_share_click",
      params: { page_name: collectList[dataSoure.index] },
    });
  };
  const firstLineShareBtn = () => {
    return (
      <>
        <TwitterShareButton
          url={shareUrl}
          title={shareText}
          beforeOnClick={beforeOnClick}
        >
          <div className="share-icon twitter"></div>
        </TwitterShareButton>
        <TelegramShareButton
          url={shareUrl}
          title={shareText}
          beforeOnClick={beforeOnClick}
        >
          <div className="share-icon telegram"></div>
        </TelegramShareButton>
        <FacebookShareButton url={shareUrl} beforeOnClick={beforeOnClick}>
          <div className="share-icon facebook"></div>
        </FacebookShareButton>
      </>
    );
  };

  const secondLineShareBtn = () => {
    return (
      <>
        <RedditShareButton
          url={shareUrl}
          title={shareText}
          beforeOnClick={beforeOnClick}
        >
          <div className="share-icon reddit"></div>
        </RedditShareButton>
        <TumblrShareButton
          url={shareUrl}
          title={shareText}
          beforeOnClick={beforeOnClick}
        >
          <div className="share-icon tumblr"></div>
        </TumblrShareButton>
        <div className="share-tip-button">
          <div className="share-icon copy_link" onClick={clipBoard}></div>
        </div>
      </>
    );
  };

  /**
   * @description: 组合分享逻辑
   * @return {*} 分享小组件
   */
  const bottomShareBlock = () => {
    return (
      <div className={`share-block-wrap ${showShareBlock && "show-block"} `}>
        <div className="share-block-content">
          <div className="close-share" onClick={handleShare(false)}>
            <CloseIcon />
          </div>
          <div className="fw-700 share-title">{t("Share")}</div>
          <div className="share-button">
            {firstLineShareBtn()}
            {secondLineShareBtn()}
          </div>
        </div>
      </div>
    );
  };

  const handleSliderChange = (index) => {
    // index: 0 - 5, 共6个NFT
    setNFTcurrentIndex(index);
  };

  const sliderSettings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "40px",
    slidesToShow: 1,
    speed: 500,
    afterChange: handleSliderChange,
  };

  // const handleChooseNFT = () => {
  //   if (canChooseNFT) {
  //     // 发放NFT
  //     sendNFT({
  //       type: "send",
  //       style: nftStyleList[NFTcurrentIndex],
  //     }).then((res) => {
  //       const { code, data = {} } = res;
  //       if (code === 20000) {
  //         // 发送成功
  //         setOwnNFT(true);
  //         setAlreadyChooseNFT && setAlreadyChooseNFT(true);
  //         // message({content: t('')})
  //       } else if (3005) {
  //         // 发放失败
  //         message({
  //           type: "noIcon",
  //           content: t("Load failed, please try again!"),
  //         });
  //       }
  //     });
  //   } else {
  //     message({
  //       type: "noIcon",
  //       content: t("Please complete all clicks", {
  //         thisYear: THIS_YEAR,
  //       }),
  //     });
  //   }
  // };

  // 处理数字隐藏
  const handleKeyWords = (type) => {
    return () => {
      setShowNum(!type);
      let list = document.querySelectorAll(".hiddenHtml");
      list.forEach((ele) => {
        if (showNum) {
          ele.setAttribute("value", ele.innerText);
          if (ele.innerText.indexOf("USDT") >= 0) {
            ele.innerText = " **** USDT ";
          } else if (ele.innerText.indexOf("%") >= 0) {
            ele.innerText = " **** % ";
          } else {
            ele.innerText = " **** ";
          }
        } else {
          ele.innerText = ele.getAttribute("value");
        }
      });
    };
  };

  const { data = {}, showMysteriousGift = false } = dataSoure;

  // 节流
  function throttle(fn, delay = 200) {
    let timer = null;
    return function () {
      var _this = this;
      if (timer) {
        return;
      }
      timer = setTimeout(function () {
        fn.apply(_this);
        timer = null;
      }, delay);
    };
  }

  const tipShareBlock = () => {
    return (
      <div className="tip-share-button">
        <div>{firstLineShareBtn()}</div>
        <div>{secondLineShareBtn()}</div>
      </div>
    );
  };
  // 分享区块
  const handleShareAllBlock = () => {
    const blockTextArr = dataSoure.data.text || [];
    const blcokTitleArr = dataSoure.data.title || [];
    const initArea = dataSoure.initArea;
    const { visit_bill_rank } = dataSoure?.data || "";
    return (
      <div className="centerner">
        <p
          id="downloadChangeTitle"
          className="centernerTitle fw-700"
          dangerouslySetInnerHTML={{ __html: shareBlocktitle }}
        ></p>
        <div className="main textColor">
          <div
            dangerouslySetInnerHTML={{
              __html: t("Congratulations on finishing journey", {
                num: setFW700(visit_bill_rank),
              }),
            }}
          ></div>
          <div className="achievements fw-700">{t("Your achievements")}</div>
          {blockTextArr.map((ele, index) => {
            return (
              <div className="single-block-content linear-border" key={index}>
                <div className="inner-single-block-content">
                  {showTipShareBlock && index === singleId && (
                    <div className="share-tip">
                      <div className="DownTriangle">
                        <DownTriangle />
                      </div>
                      {tipShareBlock()}
                    </div>
                  )}
                  <div
                    className="single-block-share-icon iconWraper"
                    onClick={() => {
                      handleSingleShareClick(index);
                    }}
                  >
                    <SingleBlockShareIcon />
                  </div>
                  <img
                    className="single-block-img"
                    src={initArea[index].URL}
                    alt="CheckpointPhoto"
                  />
                  <p
                    className="centernerTitle fw-700"
                    dangerouslySetInnerHTML={{
                      __html: blcokTitleArr[index],
                    }}
                  ></p>
                  <div
                    className="block-content"
                    dangerouslySetInnerHTML={{ __html: ele }}
                  ></div>
                  {index % 2 ? (
                    <img
                      className="single-block-content-icon-hidden"
                      style={{ width: 19, display: "none" }}
                      src={ButtonIcon}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // 关键词模块
  const handleKeyWordsBlock = () => {
    return (
      <KeyWordComponent dataSoure={dataSoure.data} annualData={annualData} />
    );
  };

  // 将分享区块与其他区块分开处理
  const handleMainContent = () => {
    if (dataSoure.data.id == achievementsID) {
      // 分享区块
      return handleShareAllBlock();
    } else if (dataSoure.data.id === keywordID) {
      // 关键词模块
      return handleKeyWordsBlock();
    } else {
      return (
        // 第 1 - 17 个区块的内容
        <div className="centerner">
          <p
            className="centernerTitle fw-700"
            dangerouslySetInnerHTML={{
              __html: dataSoure.data.title,
            }}
          ></p>
          <div
            className="main"
            dangerouslySetInnerHTML={{
              __html: dataSoure.data.text,
            }}
          ></div>
        </div>
      );
    }
  };

  const NFTArr = [NFT_01, NFT_02, NFT_03, NFT_04, NFT_05, NFT_06];

  const getKeywordStyle = () => {
    let keywordStyle = {};
    if (dataSoure.data.id === keywordID) {
      keywordStyle = {
        background: renderKeywordBackground(dataSoure.data.personality.id),
      };
    }
    return keywordStyle;
  };

  useEffect(() => {
    // 获取发送post请求的token
    const getTokenFromAgi = async () => {
      const search = window.location.search.substring(1);
      const res = await getToken(search);
      setMomentToken(res);
    };
    getTokenFromAgi();
  }, []);

  const handleShareToPost = async (imageKey) => {
    const windowUrl = `https://www.gate.io/your-year-in-review`;
    const content = `#${t("gate.year.report", { thisYear: THIS_YEAR })}#\n${t(
      "share.post.text",
      { thisYear: THIS_YEAR },
    )}\n${windowUrl}`;

    try {
      const response = await shareToPost({
        momentToken,
        content,
        images: [
          { type: "user", url: imageKey, sort: 0, width: 342, height: 580 },
        ],
      });
      const res = response.data.resMsg;
      const { code, message: messageFromAgi } = res;
      if (code === 0) {
        message({
          type: "success",
          content: messageFromAgi,
          isHomePage: true,
        });
      } else {
        message({
          type: "warning",
          content: messageFromAgi,
          isHomePage: true,
        });
      }
    } catch (error) {
      message({
        type: "warning",
        content: error,
        isHomePage: true,
      });
    }
  };

  if (!dataSoure.data) {
    return;
  }

  return (
    <div
      id="shareWrap"
      className="shareWrap"
      style={visibility}
      onClick={blcokWrapClose}
    >
      <div
        className={`content linear-border ${
          showShareBlock && "show-share-block"
        } ${blcokReturn ? "block-return" : ""} ${
          dataSoure.data.id === 19 && "nft-box"
        } ${dataSoure.data.id === keywordID && "keyword-share-box"}`}
      >
        <div className="inner-content" style={getKeywordStyle()}>
          <div className="iconBox">
            <span onClick={closePage}>
              <CloseXIcon />
            </span>
            {/* {showMysteriousGift && ownNFT && <span onClick={downPage}><DownIcon /></span>} */}
            {!window.$$device_type &&
              (!showMysteriousGift || (showMysteriousGift && ownNFT)) &&
              !showShareBlock && (
                <span
                  onClick={downPage}
                  // style={{ marginRight: 8 }}
                  className="iconWraper"
                >
                  <DownIcon />
                </span>
              )}

            <span onClick={handleKeyWords(showNum)}>
              {!showNum ? (
                <span className="iconWraper">
                  <img src={NoSightWhiteIcon} alt="" />
                </span>
              ) : (
                <span className="iconWraper">
                  <img src={SightWhiteIcon} alt="" />
                </span>
              )}
            </span>
          </div>
          {!showMysteriousGift && !isKeywordBlock && (
            <div className="imgBox">
              <img src={dataSoure?.data?.URL} alt="CheckpointPhoto" />
            </div>
          )}
          {showMysteriousGift ? (
            <div
              className={`centerner share-centerner mysterious ${
                ownNFT && "share_conterner_with_NFT"
              }`}
            >
              {ownNFT ? (
                <>
                  {/* <p className='centernerTitle no-mb fw-700'>{t('Congratulations')}</p> */}
                  <p className="centernerTitle fw-700">
                    {t("You’ve got a Gate.io 2022 Souvenir NFT!", {
                      thisYear: THIS_YEAR,
                    })}
                  </p>
                </>
              ) : (
                <>
                  {/* <p className='centernerTitle no-mb fw-700'>{t('Congratulations')}</p> */}
                  <p className="centernerTitle fw-700">
                    {t("You can claim a Gate.io 2022 souvenir NFT", {
                      thisYear: THIS_YEAR,
                    })}
                  </p>
                  <p className="explain-text">{t("Select one Gate NFT!")}</p>
                </>
              )}
              <div className={`slider-content ${!ownNFT && "no-scroll"}`}>
                {ownNFT ? (
                  <div className="share-own-NFT">
                    <img alt="NFT" src={NFTArr[NFTcurrentIndex]} />
                    <div
                      className="time-to-see-NFT"
                      dangerouslySetInnerHTML={{
                        __html: t("It will display under NFT-My Assets"),
                      }}
                    ></div>
                  </div>
                ) : (
                  <>
                    <Slider {...sliderSettings}>
                      <div className="slider-cls">
                        <img alt="NFT" src={NFT_01} />
                      </div>
                      <div className="slider-cls">
                        <img alt="NFT" src={NFT_02} />
                      </div>
                      <div className="slider-cls">
                        <img alt="NFT" src={NFT_03} />
                      </div>
                      <div className="slider-cls">
                        <img alt="NFT" src={NFT_04} />
                      </div>
                      <div className="slider-cls">
                        <img alt="NFT" src={NFT_05} />
                      </div>
                      <div className="slider-cls">
                        <img alt="NFT" src={NFT_06} />
                      </div>
                    </Slider>
                    <div className="slide_bottom_dots">
                      <i className={`${NFTcurrentIndex === 0 ? "blue" : ""}`} />
                      <i className={`${NFTcurrentIndex === 1 ? "blue" : ""}`} />
                      <i className={`${NFTcurrentIndex === 2 ? "blue" : ""}`} />
                      <i className={`${NFTcurrentIndex === 3 ? "blue" : ""}`} />
                      <i className={`${NFTcurrentIndex === 4 ? "blue" : ""}`} />
                      <i className={`${NFTcurrentIndex === 5 ? "blue" : ""}`} />
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : (
            // 处理分享区块，拿出去分开
            handleMainContent()
          )}

          {!isKeywordBlock && (
            <div
              className="button-wraper"
              style={{
                bottom: dataSoure.data.notHasLawsTips ? "40px" : "15px",
              }}
            >
              <button className="shareButton fw-700" onClick={handleShare()}>
                {dataSoure.data.id === achievementsID
                  ? t("genarate.narrative")
                  : t("Share")}
              </button>
              <div
                className="share-laws-text"
                style={{ display: dataSoure.data.notHasLawsTips ? "none" : "" }}
              >
                *{t("share.laws.text")}
              </div>
            </div>
          )}
          {!showShareBlock && !isKeywordBlock && (
            <div className="nextBox" dir="ltr">
              <span
                onClick={() => {
                  if (dataSoure?.initArea[0].id === dataSoure?.data?.id) {
                    return;
                  }
                  Switching(0)();
                  setShowShareBlock(false);
                }}
              >
                {dataSoure?.initArea[0].id === dataSoure?.data?.id ? (
                  <LastIconDisable />
                ) : (
                  <LastIcon />
                )}
              </span>
              <span
                onClick={() => {
                  if (dataSoure?.index === totleDataSourceNum - 1) {
                    return;
                  }
                  Switching(1)();
                  setShowShareBlock(false);
                }}
              >
                {dataSoure?.index === totleDataSourceNum - 1 ? (
                  <NextIconDisable />
                ) : (
                  <NextIcon />
                )}
              </span>
            </div>
          )}
        </div>
        <DonwnLoadGateWayFooter />

        {isKeywordBlock && (
          <div className="keyword-share-button-wraper">
            <div onClick={handleShare()} className="shareButton">
              <span>{t("Share")}</span>
            </div>
            <div onClick={(e) => downPage(e, true)} className="shareButton">
              <span>{t("share.post")}</span>
            </div>
          </div>
        )}
      </div>
      {bottomShareBlock()}

      {/* 加载中状态 */}
      <Loading showLoading={isLoading} />
    </div>
  );
}

export default ShareContent;
